export default __webpack_public_path__ + "static/media/part_1_img_2.9b159d00.png";